import { useContext } from "react";
import { ProjectContext } from "context/ProjectProvider";
import DistributionGroup from "pages/distribution-group";

function DistribuionGroupsSettings() {
  const { gqlClientForProject, tokenContents, eventLogs } =
    useContext(ProjectContext);

  return (
    <DistributionGroup
      gqlClientForProject={gqlClientForProject}
      tokenContents={tokenContents}
      eventLogs={eventLogs}
    />
  );
}

export default DistribuionGroupsSettings;
